import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppTheme } from '../../models/layout.model';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  standalone: false,
})
export class NavbarComponent {
  @Input() currentDate: Date = new Date();
  @Input() activeTheme: AppTheme = 'theme-blue';
  @Input() userName: string = 'User';
  @Input() userRole: string = 'Staff';
  @Input() userAvatar?: string;

  @Output() menuToggle = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();
  @Output() themeChange = new EventEmitter<AppTheme>();
  @Output() profileClick = new EventEmitter<void>();
  @Output() settingsClick = new EventEmitter<void>();

  onThemeSelect(value: string): void {
    this.themeChange.emit((value || 'theme-blue') as AppTheme);
  }

  onProfileClick(): void {
    this.profileClick.emit();
  }

  onSettingsClick(): void {
    this.settingsClick.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }
}
